export default __webpack_public_path__ + "static/mobile-salebg-e375277a3142104c190841cd0bf351a6.jpg";